module.exports = __webpack_public_path__ + "img/tip2.78d284c8.png";